import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.selection.toggleable
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.unit.dp
import banko.composeapp.generated.resources.Res
import banko.composeapp.generated.resources.dice_2d_mode
import banko.composeapp.generated.resources.dice_2d_mode_description
import banko.composeapp.generated.resources.seasonal_effects
import banko.composeapp.generated.resources.seasonal_effects_description
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject

@Composable
internal fun DiceDisplayModeToggle(preferences: PlayerPreferences = koinInject()) {
    val twoDimensional by DiceDisplayPreferences.twoDimensional.collectAsState()
    Surface(shape = RoundedCornerShape(16.dp), color = MaterialTheme.colorScheme.surfaceContainerHigh) {
        Row(
            Modifier.fillMaxWidth().toggleable(
                value = twoDimensional,
                role = Role.Switch,
                onValueChange = { DiceDisplayPreferences.setTwoDimensional(it, preferences) },
            ).padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(Modifier.weight(1f).padding(end = 12.dp)) {
                Text(stringResource(Res.string.dice_2d_mode), style = MaterialTheme.typography.bodyLarge)
                Text(stringResource(Res.string.dice_2d_mode_description),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
            Switch(checked = twoDimensional, onCheckedChange = null)
        }
    }
}

@Composable
internal fun SeasonalEffectsToggle(preferences: PlayerPreferences = koinInject()) {
    val enabled by SeasonalEffectsPreferences.enabled.collectAsState()
    Surface(shape = RoundedCornerShape(16.dp), color = MaterialTheme.colorScheme.surfaceContainerHigh) {
        Row(
            Modifier.fillMaxWidth().toggleable(
                value = enabled,
                role = Role.Switch,
                onValueChange = { SeasonalEffectsPreferences.setEnabled(it, preferences) },
            ).padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(Modifier.weight(1f).padding(end = 12.dp)) {
                Text(stringResource(Res.string.seasonal_effects), style = MaterialTheme.typography.bodyLarge)
                Text(stringResource(Res.string.seasonal_effects_description),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
            Switch(checked = enabled, onCheckedChange = null)
        }
    }
}
